// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

.form-row {
  height: 100%;
}
.form-row > ion-col {
  height: 100%;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

.header-block {
  padding: 30px 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.header-block .header-text {
  font-family: Title;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  vertical-align: baseline;
}
.header-block .header-text.accent {
  color: #c6a475;
}
.header-block .knife {
  height: 22px;
  width: 129px;
}

.wrapper-basket {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.wrapper-basket .article-wrappers {
  flex-grow: 1;
  padding-top: 10px;
  overflow-y: auto;
  margin: 0 18px 18px;
  background: #fff;
  border-radius: 9px;
}
.wrapper-basket .footer {
  border-top: 1px solid var(--color-black);
  padding-top: 10px;
  width: 100%;
}
.wrapper-basket .footer.footer-block {
  padding: 20px;
}
.wrapper-basket .footer ion-button {
  width: 100%;
  margin-bottom: 5px;
}
.wrapper-basket .footer .tips {
  border-bottom: 1px solid var(--color-black);
  padding-bottom: 10px;
}

.sub-total {
  padding: 0;
  margin-bottom: 8px;
}
.sub-total .sub-total-title,
.sub-total .sub-total-sum {
  font-family: AppFont;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}

.table-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-bottom: 1px solid var(--color-black);
}
.table-row .table-title,
.table-row .table-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.total {
  padding: 0;
}
.total .total-title,
.total .total-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.form-card {
  padding: 25px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
}
.form-card .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.form-card .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.form-card .cross-icon:hover {
  background: #f2dbd9;
}
.form-card .title {
  padding: 10px 0px;
  font-size: 20px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .form-card .title {
    margin-bottom: 30px;
  }
}
.form-card .wrapper-for-inputs {
  flex-grow: 1;
}
.form-card .footer {
  width: 100%;
}
.form-card .footer .footer-btn {
  width: 100%;
}
.form-card .footer .footer-btn:hover {
  --background: var(--primary-btn) !important;
}

.button-row {
  padding: 10px 18px;
}

.error_container {
  height: 12px;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
}

.input_group {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
  align-items: center;
}
.input_group--1 {
  grid-column: span 8;
}
.input_group--2 {
  grid-column: span 4;
}

.selection_container {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,mBAAA;AADD;;AAGA;EACC,YAAA;AAAD;AAEC;EACC,YAAA;AAAF;;AAGA;EACC,YAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,sBAAA;EACA,uBAAA;AAED;;AACA;EACC,cAAA;AAED;;AACA;EACC,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAED;AAAC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;AAEF;AAAE;EACC,cAAA;AAEH;AAEC;EACC,YAAA;EACA,YAAA;AAAF;;AAIA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;AADD;AAEC;EACC,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;AAEC;EACC,wCAAA;EACA,iBAAA;EACA,WAAA;AAAF;AACE;EACC,aAAA;AACH;AACE;EACC,WAAA;EACA,kBAAA;AACH;AACE;EACC,2CAAA;EACA,oBAAA;AACH;;AAIA;EACC,UAAA;EACA,kBAAA;AADD;AAEC;;EAEC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAAF;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;AADD;AAEC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAAF;;AAIA;EACC,UAAA;AADD;AAGC;;EAEC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AADF;;AAIA;EACC,aAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AADD;AAEC;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADF;AAEE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAAH;AAEE;EACC,mBAAA;AAAH;AAGC;EACC,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AADF;ACjKE;ED8JD;IAME,mBAAA;EACD;AACF;AAEC;EACC,YAAA;AAAF;AAEC;EACC,WAAA;AAAF;AACE;EACC,WAAA;AACH;AAAG;EACC,2CAAA;AAEJ;;AAIA;EACC,kBAAA;AADD;;AAKA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAFD;;AAKA;EACC,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;AAFD;AAIC;EACC,mBAAA;AAFF;AAKC;EACC,mBAAA;AAHF;;AAOA;EACC,mBAAA;AAJD","sourcesContent":["@import '../../../theme/mixins';\n\n:root {\n\t--ion-padding: 12px;\n}\n.form-row {\n\theight: 100%;\n\n\t& > ion-col {\n\t\theight: 100%;\n\t}\n}\nswiper-container {\n\theight: 100%;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n}\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n\n.header-block {\n\tpadding: 30px 0 30px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.header-text {\n\t\tfont-family: Title;\n\t\tfont-size: 32px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tvertical-align: baseline;\n\n\t\t&.accent {\n\t\t\tcolor: #c6a475;\n\t\t}\n\t}\n\n\t.knife {\n\t\theight: 22px;\n\t\twidth: 129px;\n\t}\n}\n\n.wrapper-basket {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\t.article-wrappers {\n\t\tflex-grow: 1;\n\t\tpadding-top: 10px;\n\t\toverflow-y: auto;\n\t\tmargin: 0 18px 18px;\n\t\tbackground: #fff;\n\t\tborder-radius: 9px;\n\t}\n\t.footer {\n\t\tborder-top: 1px solid var(--color-black);\n\t\tpadding-top: 10px;\n\t\twidth: 100%;\n\t\t&.footer-block {\n\t\t\tpadding: 20px;\n\t\t}\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\t.tips {\n\t\t\tborder-bottom: 1px solid var(--color-black);\n\t\t\tpadding-bottom: 10px;\n\t\t}\n\t}\n}\n\n.sub-total {\n\tpadding: 0;\n\tmargin-bottom: 8px;\n\t.sub-total-title,\n\t.sub-total-sum {\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.table-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid var(--color-black);\n\t.table-title,\n\t.table-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total {\n\tpadding: 0;\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n.form-card {\n\tpadding: 25px;\n\tposition: relative;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\toverflow: auto;\n\toverflow-x: hidden;\n\t.cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n\t.title {\n\t\tpadding: 10px 0px;\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t}\n\n\t.wrapper-for-inputs {\n\t\tflex-grow: 1;\n\t}\n\t.footer {\n\t\twidth: 100%;\n\t\t.footer-btn {\n\t\t\twidth: 100%;\n\t\t\t&:hover {\n\t\t\t\t--background: var(--primary-btn) !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.button-row {\n\tpadding: 10px 18px;\n\n}\n\n.error_container {\n\theight: 12px;\n\tposition: relative;\n\tmargin-bottom: 5px;\n\tmargin-top: 5px;\n}\n\n.input_group {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(12, 1fr);\n\tgap: 10px;\n\talign-items: center;\n\n\t&--1 {\n\t\tgrid-column: span 8;\n\t}\n\n\t&--2 {\n\t\tgrid-column: span 4;\n\t}\n}\n\n.selection_container {\n\tmargin-bottom: 15px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
